<template>
    <el-row type="flex" :gutter="32">
        <el-col :md="8" :sm="12" :xs="24">
            <admin-overview elementIconClass="elsa-icon-student" :numberOfElement="numberOfStudents" :elementLabel="$t($i18nLabelsHelper(currentOrganizationType, 'students'))" :elementNewLabel="$t($i18nLabelsHelper(currentOrganizationType, 'dashboard.add_student'))"> </admin-overview>
        </el-col>
        <el-col :md="8" :sm="12" :xs="24">
            <admin-overview elementIconClass="elsa-icon-class" :numberOfElement="numberOfClasses" :elementLabel="$t($i18nLabelsHelper(currentOrganizationType, 'groups_overview'))" :elementNewLabel="$t($i18nLabelsHelper(currentOrganizationType, 'create_group'))"> </admin-overview>
        </el-col>
        <el-col :md="8" :sm="12" :xs="24">
            <admin-overview elementIconClass="elsa-icon-teacher" :numberOfElement="numberOfTeachers" :elementLabel="$t($i18nLabelsHelper(currentOrganizationType, 'teachers_overview'))" :elementNewLabel="$t($i18nLabelsHelper(currentOrganizationType, 'dashboard.add_teacher'))"> </admin-overview>
        </el-col>
    </el-row>
</template>


<script>
import AdminOverview from '@/components/dashboard/AdminOverview'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
    }
  },
  components: {
    AdminOverview
  },
  props: {
    numberOfStudents: {
      type: Number,
      default: 0
    },
    numberOfClasses: {
      type: Number,
      default: 0
    },
    numberOfTeachers: {
      type: Number,
      default: 0
    },
  },
  computed: {
    ...mapGetters('organization', ['currentOrganizationType', 'currentOrganizationId']),
    ...mapState("user", ["isFirstLogin", "isElsaAdmin"]),
  },
  methods: {
  },
  async mounted() {
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>

</style>
